//import orderTemplates from '../module_biz/order/templates/orderTemplates';
import saledeliveryTemplates from '../module_biz/saledelivery/saledeliveryMain/templates/saledeliveryTemplates';
import saledeliveryEditDetailTemplates from '../module_biz/saledelivery/saledeliveryEditDetail/templates/saledeliveryEditDetailTemplates';
import saledeliveryVoucherDetailTemplates from '../module_biz/saledelivery/saledeliveryVoucherDetail/templates/saledeliveryVoucherDetailTemplates';
import saledeliverySettlementTemplates from '../module_biz/saledelivery/saledeliverySettlement/templates/saledeliverySettlementTemplates';
import saledeliveryMultiSettlementTemplates from '../module_biz/saledelivery/saledeliveryMultiSettlement/templates/saledeliveryMultiSettlementTemplates';
import saledeliveryPriceAvailableTemplates from '../module_biz/saledelivery/saledeliveryPriceAvailable/templates/saledeliveryPriceAvailableTemplates';
import saledeliveryBatchListTemplates from  '../module_biz/saledelivery/saledeliveryBatchList/templates/saledeliveryBatchListTemplates';
import preReceiveseListTemplates from '../module_biz/saledelivery/preReceiveseList/templates/preReceiveseListTemplates';

export default {
  saledeliveryTemplates,
  saledeliveryEditDetailTemplates,
  saledeliveryVoucherDetailTemplates,
  saledeliverySettlementTemplates,
  saledeliveryMultiSettlementTemplates,
  saledeliveryPriceAvailableTemplates,
  saledeliveryBatchListTemplates,
  preReceiveseListTemplates
};
